export const marketplace = {
  marketplaceSearchInputPlaceholderTitle: 'Cerca',
  marketplaceDetailsCurtainCopyOptionTitle: 'Copia link',
  marketplaceDetailsCurtainFlagOptionTitle: 'Segnala contenuto',
  marketplaceDetailsCurtainCopiedAlertText: 'Link copiato!',
  marketplaceDetailsFlagCurtainTitle: 'Segnala',
  marketplaceReportedCurtainContent: 'Contenuto segnalato',
  marketplaceAllItems: 'Tutti gli articoli',
  marketplaceWantToBuy: 'Voglio acquistare {item} da {appname}'
}
